import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {

        //左侧菜单栏数据
        // menuItems: [
        //     {
        //         name: "home", // 要跳转的路由名称 不是路径
        //         size: 18, // icon大小
        //         type: "md-home", // icon类型
        //         text: "主页" // 文本内容
        //     },
        //     {
        //         text: "基础信息",
        //         type: "ios-paper",
        //         children: [
        //             {
        //                 type: "ios-grid",
        //                 name: "address_menu",
        //                 text: "地址信息"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "governing_body_menu",
        //                 text: "管辖机构信息"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "personnel_body_menu",
        //                 text: "员工信息"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "meter_menu",
        //                 text: "表具信息"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "meter_type",
        //                 text: "表具类型"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "import_file",
        //                 text: "基础信息导入"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "ladderPrice",
        //                 text: "阶梯气价"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "gastype",
        //                 text: "用气类型"
        //             }
        //         ]
        //     },
        //     {
        //         text: "设备交互",
        //         type: "ios-paper",
        //         children: [
        //             {
        //                 type: "ios-grid",
        //                 name: "up_instructions_menu",
        //                 text: "查询上传指令"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "down_instructions_menu",
        //                 text: "查询下发指令"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "instructions_detailed_menu",
        //                 text: "设备交互"
        //             }
        //         ]
        //     },
        //     {
        //         text: "设备维护",
        //         type: "ios-paper",
        //         children: [
        //             {
        //                 type: "ios-grid",
        //                 name: "open_account",
        //                 text: "设备开户"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "recharge",
        //                 text: "充值"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "order_create",
        //                 text: "工单维护"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "abnormal_detailed",
        //                 text: "异常监控"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "push_msg",
        //                 text: "消息发布"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "record_msg",
        //                 text: "消息记录"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "set_up_repair_list",
        //                 text: "报警开关"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "push_exception_config",
        //                 text: "报警推送配置"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "customer_response",
        //                 text: "用户反馈"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "gas_appliances",
        //                 text: "燃气用具"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "customer_gas_application",
        //                 text: "用户燃气用具"
        //             }
        //         ]
        //     },
        //     {
        //         text: "图表展示",
        //         type: "ios-paper",
        //         children: [
        //             {
        //                 type: "ios-grid",
        //                 name: "eCharts_exception",
        //                 text: "报警图例"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "eCharts_sales",
        //                 text: "营业额图例"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "eCharts_flow",
        //                 text: "用气量图例"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "pipeline",
        //                 text: "管道泄漏"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "eChart_test",
        //                 text: "测试图例"
        //             }
        //         ]
        //     },
        //     {
        //         text: "权限管理",
        //         type: "ios-paper",
        //         children: [
        //             {
        //                 type: "ios-grid",
        //                 name: "managep_permission",
        //                 text: "权限管理"
        //             }
        //         ]
        //     },
        //     {
        //         text: "生产管理",
        //         type: "ios-paper",
        //         children: [
        //             {
        //                 type: "ios-grid",
        //                 name: "meter_regist",
        //                 text: "设备批量注册"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "meter_export",
        //                 text: "基表信息导出"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "up_instructions_menu",
        //                 text: "查询上传指令"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "down_instructions_menu",
        //                 text: "查询下发指令"
        //             },
        //             {
        //                 type: "ios-grid",
        //                 name: "instructions_detailed_produce",
        //                 text: "设备交互(生产)"
        //             }
        //         ]
        //     }
        // ]
        menuItems: [
          {
            name: "home", // 要跳转的路由名称 不是路径
            size: 18, // icon大小
            type: "md-home", // icon类型
            text: "主页" // 文本内容
          },
          {
            text: "生产管理",
            type: "ios-paper",
            children: [
              {
                type: "ios-grid",
                name: "meter_regist",
                text: "设备批量注册"
              },
              {
                type: "ios-grid",
                name: "meter_export",
                text: "基表信息导出"
              },
              {
                type: "ios-grid",
                name: "up_instructions_menu",
                text: "查询上传指令"
              },
              {
                type: "ios-grid",
                name: "down_instructions_menu",
                text: "查询下发指令"
              },
              {
                type: "ios-grid",
                name: "instructions_detailed_produce",
                text: "设备交互(生产)"
              }
            ]
          }
        ]
    },
    mutations: {
        setMenus(state, items) {
            state.menuItems = [...items]
        },
    }
})

export default store